import {Action, createReducer, on} from '@ngrx/store';
import * as Actions from '@account/store/actions/config.action';
import {ConfigState, initialConfigState} from '@account/store/state/config.state';

export const initialState: {} | ConfigState = initialConfigState()

const ConfigReducer = createReducer(
  initialState,
  on(
    Actions.setProductDB, (state: ConfigState | {}, {productDBToken, productDBCopyFields}): ConfigState => {
      return {
        ...state,
        productDBToken,
        productDBCopyFields
      };
    })
);

export function reducer(state: ConfigState | {} | undefined, action: Action) {
  return ConfigReducer(state, action);
}
